export const quickAnswer =
  'Choose for your playstyle: defense, aerial attacks or weapon-supported fire. Compare the trade-offs before committing.';

## Combat Choice Groups

Artist, Dancer, Deserter, Collective and Physicist each offer a choice. The first three groups have focused comparisons below. Command is a fixed unlock rather than an alternative.

## Traversal and Combat

Traversal powers help you reach new routes; this collection concentrates on combat decisions.

## Plan Your Choices

Use the [Build Planner](/build-planner) to record your preferences. There is no universal best build or numeric damage ranking here.
